import {
  CategoryFilter,
  NotificationFilterState,
  NotificationSort,
  Severity,
  TimeFilter,
} from "./types";

export const DEFAULT_FILTERS: NotificationFilterState = {
  severity: "ALL",
  category: "All",
  time: "All",
};

export const DEFAULT_SORT: NotificationSort = "NEWEST_FIRST";

export const SEVERITY_OPTIONS: { value: Severity; label: string }[] = [
  { value: "ALL", label: "All" },
  { value: "CRITICAL", label: "Critical" },
  { value: "HIGH", label: "High" },
  { value: "MEDIUM", label: "Medium" },
  { value: "LOW", label: "Low" },
];

export const CATEGORY_OPTIONS: { value: CategoryFilter; label: string }[] = [
  { value: "All", label: "All" },
  { value: "WEATHER", label: "Weather" },
  { value: "PAX_SECURITY", label: "Pax Security" },
  { value: "BAGGAGE", label: "Baggage" },
];

export const TIME_OPTIONS: { value: TimeFilter; label: string }[] = [
  { value: "All", label: "All" },
  { value: "30min", label: "30 min" },
  { value: "1Hour", label: "1 Hour" },
  { value: "6Hours", label: "6 Hours" },
  { value: "12Hours", label: "12 Hours" },
  { value: "24Hours", label: "24 Hours" },
  { value: "3Days", label: "3 Days" },
  { value: "7Days", label: "7 Days" },
  { value: "OlderThan7Days", label: "> 7 Days" },
];

export const SORT_OPTIONS: {
  value: NotificationSort;
  label: string;
}[] = [
  {
    value: "NEWEST_FIRST",
    label: "Newest first",
  },

  {
    value: "OLDEST_FIRST",
    label: "Oldest first",
  },
];
